import React from "react";
import { node, object, string } from "prop-types";
import HeroBrand from "../../../../../ui/HeroBrand";

const SectionHero = ({ brandCode, heroConfig, children, ...props }) => {
	return (
		<HeroBrand brandCode={brandCode} config={heroConfig} {...props}>
			{children}
		</HeroBrand>
	);
};

SectionHero.propTypes = {
	brandCode: string,
	heroConfig: object, // eslint-disable-line react/forbid-prop-types
	children: node.isRequired,
};

export default SectionHero;
